/**
 * First-run onboarding state (localStorage only).
 */
import { loadFiltersFromStorage, saveFiltersToStorage } from './filterPersistence';
import { DEFAULT_INDEX_FILTER } from '../constants';

export const ONBOARDING_STORAGE_KEY = 'onboarding_completed_v1';
export const ONBOARDING_STEP_SESSION_KEY = 'onboarding_step_v1';

/** Where users land after login, and after completing (or skipping) getting
 *  started. /terminal, not WORKFLOW_ROUTES.setups: both routes render
 *  TerminalHomePage, but /setups is the legacy path the workflow rail and the
 *  analytics source map still key on, so landing there put every fresh session
 *  on a URL the terminal does not otherwise use. */
export const ONBOARDING_HOME_PATH = '/terminal';
/* KAN-65 item 5: "Show me today's setups" framed TS as a picks app in the
   first sixty seconds — the CTA now opens the workspace, not a platform list. */
export const ONBOARDING_LAST_CTA_LABEL = 'Open the Terminal';

const DASHBOARD_DEFAULT_FILTERS = {
  instrumentType: 'all',
  strategy: [],
  days: 30,
  confidence: [0, 100],
  signalDirection: 'all',
  signalStatus: 'all',
  index: [...DEFAULT_INDEX_FILTER],
  pattern: [],
  viewMode: 'chart',
  sortBy: 'market_cap_desc',
  onlyLatestSignalStocks: false,
  matchMode: 'OR',
  stockSymbols: [],
  onlyChartsWithPatterns: false,
  behavior: [],
  timeframe: 'daily',
};

export function isOnboardingComplete() {
  try {
    return localStorage.getItem(ONBOARDING_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function markOnboardingComplete() {
  try {
    localStorage.setItem(ONBOARDING_STORAGE_KEY, '1');
  } catch (e) {
    console.warn('Failed to save onboarding state:', e);
  }
}

export function clearOnboardingComplete() {
  try {
    localStorage.removeItem(ONBOARDING_STORAGE_KEY);
  } catch (e) {
    console.warn('Failed to clear onboarding state:', e);
  }
  clearOnboardingStep();
}

/* KAN-63 item 7: acknowledgeLegalDisclaimer() is deliberately GONE. Completing
   onboarding used to pre-dismiss the Setups legal banner, so the SEBI
   non-registration disclosure was never actually seen by completers. The
   disclosure is now the always-visible ComplianceRibbon — nothing may
   acknowledge it away. Do not reintroduce. */

/** Refresh-resume: remember which step the user was on within this tab session. */
export function loadOnboardingStep(maxIndex) {
  try {
    const raw = sessionStorage.getItem(ONBOARDING_STEP_SESSION_KEY);
    const idx = parseInt(raw, 10);
    if (Number.isFinite(idx) && idx >= 0 && idx <= maxIndex) return idx;
  } catch {
    /* ignore */
  }
  return 0;
}

export function saveOnboardingStep(index) {
  try {
    sessionStorage.setItem(ONBOARDING_STEP_SESSION_KEY, String(index));
  } catch {
    /* ignore */
  }
}

export function clearOnboardingStep() {
  try {
    sessionStorage.removeItem(ONBOARDING_STEP_SESSION_KEY);
  } catch {
    /* ignore */
  }
}

/** Persist selected index/universe for Scan + Overview filter hydration. */
export function saveOnboardingUniverse(indexId) {
  const current = loadFiltersFromStorage(DASHBOARD_DEFAULT_FILTERS);
  const nextIndex = indexId ? [indexId] : [...DEFAULT_INDEX_FILTER];
  saveFiltersToStorage({
    ...current,
    index: nextIndex,
  });
  if (typeof window !== 'undefined') {
    window.dispatchEvent(
      new CustomEvent('onboarding-universe-saved', { detail: { index: nextIndex } }),
    );
  }
}
